import React, { PureComponent, ReactNode } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';
import { connect } from 'react-redux';

import Heading from '@atlaskit/heading';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import {
  getPullRequestAttributes,
  publishPrAnalyticsFileViewFolder,
} from 'src/sections/repository/sections/pull-request/hooks/analytics';
import { PullRequestAttribute } from 'src/sections/repository/types';
import { BucketState } from 'src/types/state';

import messages from './i18n';
import * as styles from './styled';

export type DirectoryProps = {
  children: ReactNode;
  defaultCollapsed: boolean;
  intl: InjectedIntl;
  name: string;
  prAttributes: PullRequestAttribute;
  fileCount: number;
};

export type DirectoryState = {
  isCollapsed: boolean;
};

// @ts-ignore TODO: fix noImplicitAny error here
const toggleCollapseStateUpdater = (prevState): DirectoryState => ({
  isCollapsed: !prevState.isCollapsed,
});

const mapStateToProps = (state: BucketState) => ({
  prAttributes: getPullRequestAttributes(state),
});

class Directory extends PureComponent<DirectoryProps, DirectoryState> {
  static defaultProps = {
    /* eslint react/default-props-match-prop-types: "warn" */
    defaultCollapsed: true,
  };

  constructor(props: DirectoryProps) {
    super(props);

    const { defaultCollapsed } = this.props;

    this.state = {
      isCollapsed: defaultCollapsed,
    };
  }

  toggleDirectory = (): void => {
    this.setState(toggleCollapseStateUpdater);

    publishPrAnalyticsFileViewFolder(
      this.props.prAttributes,
      this.props.name,
      this.state.isCollapsed
    );
  };

  renderFolderIcon() {
    const { intl } = this.props;
    const { isCollapsed } = this.state;
    const iconColor = token('color.text.subtlest', '#6B778C');

    return (
      <styles.DirectoryFolder>
        {isCollapsed ? (
          <ChevronRightIcon
            label={intl.formatMessage(messages.directory)}
            primaryColor={iconColor}
          />
        ) : (
          <ChevronDownIcon
            label={intl.formatMessage(messages.directory)}
            primaryColor={iconColor}
          />
        )}
      </styles.DirectoryFolder>
    );
  }

  render() {
    const { children, name, fileCount } = this.props;
    const { isCollapsed } = this.state;

    return (
      <styles.Directory>
        <styles.DirectoryHeader
          isCollapsed={isCollapsed}
          aria-expanded={!isCollapsed}
          onClick={this.toggleDirectory}
          onMouseDown={e => e.preventDefault()}
        >
          {this.renderFolderIcon()}
          <styles.TooltipWrapper>
            <Tooltip position="left" content={name}>
              <styles.FileName>
                <Heading level="h200" as="span">
                  {isCollapsed && fileCount ? `${name} (${fileCount})` : name}
                </Heading>
              </styles.FileName>
            </Tooltip>
          </styles.TooltipWrapper>
        </styles.DirectoryHeader>
        {!isCollapsed && (
          <styles.DirectoryContent role="list">
            {children}
          </styles.DirectoryContent>
        )}
      </styles.Directory>
    );
  }
}

export default connect(mapStateToProps)(injectIntl(Directory));
